import { BookmarkBorderSharpIcon, BookmarkSharpIcon } from '@cmg/design-system';
import React, { useCallback, useState } from 'react';

export type IssuerFollowButtonProps = Readonly<{
  onClick: (isFollowing: boolean) => void;
  isFollowing: boolean;
}>;

export const IssuerFollowButton: React.FC<IssuerFollowButtonProps> = ({
  isFollowing: isFollowingInitial,
  onClick,
}) => {
  const [isFollowing, setIsFollowing] = useState<boolean>(isFollowingInitial);

  const handleClick = useCallback(() => {
    setIsFollowing(prev => !prev);
    onClick(!isFollowing);
  }, [isFollowing, onClick]);

  const IconComponent = isFollowing ? BookmarkSharpIcon : BookmarkBorderSharpIcon;

  return (
    <IconComponent
      cursor="pointer"
      onClick={handleClick}
      fontSize="small"
      color="action"
      aria-label={isFollowing ? 'Unfollow' : 'Follow'}
    />
  );
};
